import { render, staticRenderFns } from "./Rekayasalalin.vue?vue&type=template&id=af71064c&scoped=true"
import script from "./Rekayasalalin.vue?vue&type=script&lang=js"
export * from "./Rekayasalalin.vue?vue&type=script&lang=js"
import style0 from "./Rekayasalalin.vue?vue&type=style&index=0&id=af71064c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71064c",
  null
  
)

export default component.exports